<template>
  <div class="add-user-page" autocomplete="off">
    <Loading v-if="loading" />
    <div v-if="!loading">
      <b-row>
        <b-col md="8">
          <h2 class="page-title">
            <span v-if="!existingUser">Add User</span>
            <span v-else>Update User</span>
          </h2>
        </b-col>
      </b-row>
      <b-card title="User Details">
        <b-row>
          <b-col md="6">
            <b-form-group label="First Name">
              <b-form-input
                v-model="firstName"
                class="mb-2"
                fade="true"
                :class="{
                  error:
                    !form.firstName.minLength.hasMinLength ||
                    !form.firstName.valid
                }"
                autocomplete="off"
                label="First Name"
                placeholder="Enter First Name"
              >
              </b-form-input>
              <transition name="fade">
                <b-alert
                  v-if="!form.firstName.valid"
                  show
                  variant="danger"
                  class="error col-md-6 mt-1"
                  >Name must have at least
                  {{ form.firstName.minLength.length }} letters.</b-alert
                >
              </transition>
            </b-form-group>
            <b-form-group label="Last Name">
              <b-form-input
                v-model="lastName"
                class="mb-2"
                :class="{
                  error:
                    !form.lastName.minLength.hasMinLength ||
                    !form.lastName.valid
                }"
                autocomplete="off"
                label="Last Name"
                placeholder="Enter Last Name"
              >
              </b-form-input>
              <transition name="fade">
                <b-alert
                  v-if="!form.lastName.valid"
                  name="fade"
                  tag="b-alert"
                  show
                  fade="true"
                  variant="danger"
                  class="error col-md-6 mt-1"
                  >Last Name must have at least
                  {{ form.lastName.minLength.length }} letters.</b-alert
                ></transition
              >
            </b-form-group>
            <b-form-group v-if="!existingUser" label="Password">
              <b-form-input
                v-model="password"
                class="mb-2"
                label="Password"
                placeholder=""
                disabled
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Email">
              <b-form-input
                v-model="email"
                class="mb-2"
                :class="{ error: !isEmailValid() || !form.email.valid }"
                label="Email"
                autocomplete="off"
                type="email"
                placeholder="Enter Email"
              >
              </b-form-input>
              <transition name="fade">
                <b-alert
                  v-if="!form.email.valid"
                  show
                  variant="danger"
                  class="error col-md-6 mt-1"
                  >{{
                    email ? "Email format is incorrect" : "Please enter email"
                  }}</b-alert
                >
              </transition>
            </b-form-group>
            <b-form-group label="Roles">
              <vue-tags-input
                v-if="!userEditingThemself"
                id="roleInput"
                v-model="role"
                class="tag-custom text-14 tag-custom"
                :add-only-from-autocomplete="true"
                :tags="roles"
                autocomplete="off"
                :autocomplete-items="filteredRoles"
                placeholder="Type Role Name"
                @tags-changed="newRoles => (roles = newRoles.map(x => x.text))"
              />
              <template v-else>
                <em class="warning-text"
                  >You cannot edit your <strong>own</strong> roles</em
                >
                <b-row>
                  <b-col v-for="userRole in roles" :key="userRole" md="2">
                    <b-badge pill variant="info">{{ userRole }}</b-badge>
                  </b-col>
                </b-row>
              </template>
            </b-form-group>
            <b-form-group v-if="!existingUser" label="Avatar">
              <p class="file-info">Must be a .png file</p>
              <b-form-file
                id="avatarUploader"
                v-model="avatar"
                type="file"
                :class="{ fileInputError: !form.avatar.valid }"
                placeholder="Choose or drop avatar here"
                drop-placeholder="Drop avatar here"
                variant="primary"
                value="Upload"
              />
            </b-form-group>
            <b-alert
              v-if="!form.avatar.valid"
              show
              variant="danger"
              class="error col-md-6 mt-1"
              >Please upload an avatar for this user</b-alert
            >
            <b-button
              v-if="!existingUser"
              type="submit"
              class="save-btn"
              variant="primary"
              @click="submitForm"
              >Save</b-button
            >
            <b-button
              v-else
              type="submit"
              class="save-btn"
              variant="primary"
              @click="updateUser"
              >Update</b-button
            >
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>
<script>
import Loading from "@/components/loading"
import generator from "generate-password"
import { mapGetters, mapMutations } from "vuex"
export default {
  layout: "default",
  components: {
    Loading
  },
  apollo: {
    existingUser: {
      query: require("@/graphql/Account/GetUser.gql"),
      variables() {
        return {
          userId: this.$route.params.userId
        }
      },
      skip() {
        return !this.$route.params.userId
      },
      update(data) {
        //This is an update not an add
        if (!data.user) {
          this.$toasted.error("User not found")
          this.$router.back()
        }
        this.firstName = data.user.firstName
        this.lastName = data.user.lastName
        this.email = data.user.email
        this.roles = data.user.roles
        return data.user
      }
    }
  },
  data() {
    return {
      valid: false,
      loading: true,
      firstName: "",
      lastName: "",
      nickname: "",
      avatar: null,
      email: "",
      fileArray: null,
      password: generator.generate({
        length: 10,
        numbers: true,
        uppercase: true,
        strict: true,
        symbols: false
      }),
      type: "",
      types: [],
      autocompletetypes: ["Developer", "Management", "SocialMedia", "Designer"],
      role: "",
      roles: ["User"],
      autocompleteRoles: ["Super Admin", "Admin", "User"],
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      form: {}
    }
  },
  computed: {
    ...mapGetters({
      getUserById: "getUserById",
      getCurrentUser: "getCurrentUser"
    }),
    avatarSaveUrl() {
      return "/UserAvatars/" + this.avatar.name
    },
    userEditingThemself() {
      return this.existingUser?.id == this.getCurrentUser.id
    },
    filteredTypes() {
      return this.autocompletetypes.filter(item => {
        return item.toLowerCase().indexOf(this.type.toLowerCase()) !== -1
      })
    },
    filteredRoles() {
      return this.autocompleteRoles.filter(item => {
        return item.toLowerCase().indexOf(this.role.toLowerCase()) !== -1
      })
    },
    lowerCaseTypes() {
      return this.types.map(x => x.toLowerCase())
    },
    teamParameter() {
      switch (this.types[0].toLowerCase()) {
        case "designer":
          return "designers"
        case "developer":
          return "developers"
        case "management":
          return "managing"
        default:
          return this.types[0].toLowerCase()
      }
    },
    currentUser() {
      return this.$store.getters["users/getUserByUID"](
        this.$store.state.users.current_user.uid
      )
    },
    userIsAdmin() {
      return (
        this.currentUser &&
        this.currentUser.roles &&
        (this.currentUser.roles.includes("Admin") ||
          this.currentUser.roles.includes("Super Admin"))
      )
    }
  },
  watch: {
    firstName(newValue) {
      const hasMinLength =
        this.minLength(newValue, 3) && (this.form.firstName.valid = true)
      this.form.firstName.minLength.hasMinLength = hasMinLength
    },
    lastName(newValue) {
      const hasMinLength =
        this.minLength(newValue, 3) && (this.form.lastName.valid = true)
      this.form.lastName.minLength.hasMinLength = hasMinLength
    },
    types() {
      if (this.types.length !== 0) {
        this.types.forEach(type => {
          this.form.type.correctInput = [
            "Developer",
            "Management",
            "SocialMedia",
            "Designer"
          ].includes(type)
        })
        if (!this.form.type.correctInput) {
          this.form.type.errorMessage =
            "Please select one of the approved Roles"
        }
      } else {
        this.form.type.correctInput = true
        this.form.type.errorMessage = "Please select a Role for this user"
      }
      this.form.type.valid = true
    },
    email() {
      this.form.email.valid = this.email !== "" || this.form.email.validFormat
    },
    avatar() {
      this.form.avatar.valid = true
    }
  },
  mounted() {
    // document.getElementsByTagName("input").tagInput.classList.add("tag-custom")
    document.getElementsByTagName("input").roleInput.classList.add("tag-custom")
  },
  beforeMount() {
    this.form = {
      firstName: {
        minLength: {
          hasMinLength: true,
          length: 3
        },
        required: true,
        valid: true
      },
      lastName: {
        minLength: {
          hasMinLength: true,
          length: 3
        },
        required: true,
        valid: true
      },
      nickname: {
        minLength: {
          hasMinLength: true,
          length: 3
        },
        required: false,
        valid: true
      },
      email: {
        required: true,
        validFormat: this.isEmailValid(),
        valid: true
      },
      type: {
        required: true,
        valid: true,
        correctInput: false,
        errorMessage: ""
      },
      avatar: {
        valid: true
      }
    }
    switch (this.$route.params.role) {
      case "developers":
        this.types.push("Developer")
        break
      case "socialmedia":
        this.types.push("SocialMedia")
        break
      case "designers":
        this.types.push("Designer")
        break
      case "managing":
        this.types.push("Management")
    }
  },
  created() {
    this.loading = false
  },
  methods: {
    ...mapMutations({
      setUser: "setUser",
      addUserToState: "addUser"
    }),
    updateUser() {
      this.$apollo
        .mutate({
          mutation: require("@/graphql/Account/UpdateUser.gql"),
          variables: {
            user: {
              firstName: this.firstName,
              lastName: this.lastName,
              email: this.email,
              roles: this.roles,
              id: this.existingUser.id
            }
          }
        })
        .then(async data => {
          await this.updateSuccess()
          //Update user in the Vuex state
          this.setUser(data.data.updateUser)
        })
        .catch(error => {
          console.log(error)
          this.$toasted.error("Error encountered")
        })
    },
    async updateSuccess() {
      this.$toasted.success("User updated")
      this.$router.push("/Users/ManageUsers")
    },

    async addUserWithAvatar() {
      const result = await this.$utils.mutateWithFile(
        `mutation register($user: UserInput!){
          register(user:$user){
              email
              id
              firstName
              lastName
              roles
              avatar
          }
        }`,
        this.avatar,
        {
          user: {
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            roles: this.roles,
            password: this.password
          }
        }
      )
      if (!result.data.register) this.addUserFailure()
      else this.addUserSuccess(result.data.register)
    },
    isEmailValid() {
      return this.email == "" || this.reg.test(this.email)
    },
    minLength(text, size) {
      return text == "" || text.length >= size
    },
    submitForm() {
      //Form Validation
      this.valid = true
      if (!this.form.firstName.minLength.hasMinLength || !this.firstName) {
        this.form.firstName.valid = false
        this.valid = false
      }
      if (!this.form.lastName.minLength.hasMinLength || !this.lastName) {
        this.form.lastName.valid = false
        this.valid = false
      }
      if (!this.form.email.validFormat || this.email === "") {
        this.form.email.valid = false
        this.valid = false
      }

      if (!this.avatar) {
        this.valid = false
        this.form.avatar.valid = false
      }
      if (this.valid) this.addUserWithAvatar()
    },
    addUserSuccess(user) {
      this.$toasted.success("User Successfully Added")
      this.addUserToState(user)
      this.$router.push("/Users/ManageUsers")
    },
    addUserFailure() {
      this.$toasted.error("An unexpected error occurred")
    }
  }
}
</script>
<style scoped>
.error {
  border-color: #f30000 !important;
  /* border-color: #dc5050 !important; */
  box-shadow: 0 0 10px 0.2rem rgba(181, 0, 0, 0.25);
  /* box-shadow: 0 0 0 0.2rem rgba(181, 0, 0, 0.25); */
}
.fileInputError {
  box-shadow: 0 0 10px 0.2rem rgba(181, 0, 0, 0.25);
}
.vue-tags-input {
  max-width: unset !important;
}
.card-profile-1 .avatar {
  width: 20% !important;
  height: 20% !important;
}
.save-btn {
  margin-top: 10px;
  float: right;
}
.ti-tag[data-v-61d92e31] {
  background: #f8f9fa !important;
  color: #0b192b !important;
}

.ti-input {
  border-radius: 0.25rem;
}
.tag-custom {
  background: #f8f9fa !important;
  color: #0b192b !important;
}

#tagInput [type="input"] {
  background: #f8f9fa !important;
  color: #0b192b !important;
}
#roleInput [type="input"] {
  background: #f8f9fa !important;
  color: #0b192b !important;
}
input {
  background: #f8f9fa !important;
}
.mt-1,
.my-1 {
  margin-top: 15px !important;
}
.add-user-page {
  margin-bottom: 25px;
}

.upload-btn {
  float: right;
  margin-right: 5px;
  margin-top: 10px;
}
.file-info {
  margin: 0;
  font-size: 10px;
  font-weight: bold;
  color: #37c162;
}

.warning-text {
  color: lightcoral;
}
</style>
